import
  React, {
  useEffect,
  useState
} from 'react';

import {
  useHistory
} from 'react-router-dom';

import
  styled
from 'styled-components';

import {
  HContainer,
  Image,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../../../constants';

import {
  HandleRender,
  withScreenViewTagging
} from 'hocs';

import {
  DrupalProvider
} from 'providers';

import {
  BackButton
} from 'components';

import {
  isEqual
} from 'helpers';

const PageContainer = styled(VContainer)`
  overflow-x: hidden;
  overflow-wrap: break-word;
`;

const StyledButtonContainer = styled(VContainer)`
  position: fixed;
  top: 0;
  z-index: 1;
  width: 100%;
  background-color: ${CustomColors.White};
`;

const AirtimeAdvanceLegalUI = props => {

  const history = useHistory();

  const mountedRef = React.useRef(true);

  const getPage = async () => {

    const response = await DrupalProvider.getCachedItem('pages', null, DrupalProvider.getPages);

    if (!mountedRef.current) {
      return;
    }

    if (response?.result) {
      setState({
        ...state,
        loading: false
      });
      setPage(response.result.find(page => isEqual(page.title, 'Airtime Advance Terms and Conditions')));
    }
  };

  const [ page, setPage ] = useState(null);
  const [ state, setState ] = useState({
    loading: true,
    hasError: false,
    error: null
  });

  useEffect(() => {

    const init = async () => {
      await getPage();
    };

    init();

    return () => {
      mountedRef.current = false;
    };
  }, []);

  return (

    <HandleRender
      isLoading={state.loading}
      isError={!state.loading && !page} >

      <StyledButtonContainer>
        <BackButton
          onClick={() => history.goBack()} />
      </StyledButtonContainer>

      { page &&
        <PageContainer
          height={'100%'}
          padding={'85px 16px 0'}>

            <HContainer
              key={'landing-page-logo'}>

              <VContainer
                margin={'0 16px 16px 0'}>

                <Image
                  src={Icons.VodacomLogo}
                  width={'50px'}
                  height={'50px'}
                  margin={'0 17px 0 0'}/>

              </VContainer>

              <Image
                src={Icons.ConnectU}
                width={'164px'}
                height={'40px'}/>

            </HContainer>

            <Text
              fontSize={'26px'}
              fontWeight={'bold'} >

              {page.title}
            </Text>

            <Text
              fontSize={'16px'}
              dangerouslySetInnerHTML={{ __html: page.content }}/>

        </PageContainer>
      }
    </HandleRender>
  );
};

AirtimeAdvanceLegalUI.pageName = 'cbu: connectu: agree to terms and conditions';

export const AirtimeAdvanceLegal = withScreenViewTagging(AirtimeAdvanceLegalUI);